import { cn, formatDate, formatMoney, formatNumber } from '@linka/utils';

type IndicatorCardProps = {
  label: string;
  value: string | number | null;
  type?: 'money' | 'date' | 'percent';
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
};

export const IndicatorCard = ({ label, value, type, className }: IndicatorCardProps) => {
  return (
    <div className={cn('flex flex-col justify-between gap-nano bg-base-gray-100 rounded-md p-mini', className)}>
      <p className='ts-paragraph-xxs text-ctx-content-base truncate'>{label}</p>
      <p className='ts-heading-md text-ctx-content-title'>{formatIndicatorValue(value, type)}</p>
    </div>
  );
};
const formatStrategies: Record<string, (val: string | number) => string | number> = {
  money: (val) => (typeof val === 'number' ? formatMoney(val, false) : val),
  // `peakSalesDate` chega como data de calendário "YYYY-MM-DD", sem instante — daí
  // `formatDate`, que não recua um dia como `new Date` faria em UTC-3.
  date: (val) => formatDate({ date: String(val), dateFormat: 'dd/MM/yyyy' }) ?? '---',
  number: (val) => (typeof val === 'number' ? formatNumber(val) : val),
  percent: (val) => (typeof val === 'number' ? formatNumber(val / 100, { style: 'percent' }) : val),
};

/**
 * Converte um valor de dedução em negativo para exibição no card (ex.: estorno de 10 vira -10).
 * Zero continua zero: negar 0 dá -0, que o `Intl.NumberFormat` exibe como "-R$ 0,00".
 */
export const toDeductionValue = (amount: number) => (amount === 0 ? 0 : -amount);

export const formatIndicatorValue = (value: IndicatorCardProps['value'], type?: keyof typeof formatStrategies) => {
  if (value === null) return '---';
  const strategy = type ? formatStrategies[type] : formatStrategies.number;
  return strategy(value);
};
